import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { slugify } from "../../custom_utils/helpers";
import { Block } from "./library/container";
export const HighlightBlock = (p)=>/*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "highlight",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    "data-anchor": slugify(p.title),
                    className: "highlight__title title--s",
                    children: p.title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "highlight__subtitle",
                    children: p.subtitle
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "highlight__text",
                    dangerouslySetInnerHTML: {
                        __html: p.content
                    }
                })
            ]
        })
    });
